import * as React from "react";

/**
 * Hook for getting, setting, and deleting cookies
 */
export const useCookies = () => {

    const setCookie = (cname: string, cvalue: any, exdays: number) => {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    const getCookie = (cname: string) => {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    const deleteCookie = (cname: string) => {
        var d = new Date();
        d.setTime(d.getTime() - (12 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "= ;" + expires + ";path=/";
    }

    return [getCookie, setCookie, deleteCookie] as const;
};